import { Component, Input, OnInit } from '@angular/core';
import { BasicArticleDefinition } from '../../article-type.model';

@Component({
    selector: 'app-article-type-base-article-definition-list',
    templateUrl: './article-type-base-article-definition-list.component.html',
    styleUrls: ['./article-type-base-article-definition-list.component.scss'],
    standalone: false
})
export class ArticleTypeBaseArticleDefinitionListComponent implements OnInit {

  _definition: BasicArticleDefinition;

  @Input() set definition(definition: BasicArticleDefinition) {
    this._definition = definition;
    console.log('ArticleTypeBaseArticleDefinitionListComponent.def', this.definition);
  }

  get definition() {
    return this._definition;
  }

  constructor(
  ) { }

  ngOnInit(): void {
    this.sortBasicArticleDefintionAttributes();
  }

  private sortBasicArticleDefintionAttributes() {
    this.definition?.attributes?.sort( (a, b) => {
      if (a == null || a.articleTypeAttribute == null || a.articleTypeAttribute.sortValue == null) {
        return -1;
      }
      if (b == null || b.articleTypeAttribute == null || b.articleTypeAttribute.sortValue == null) {
        return 1;
      }
      return a.articleTypeAttribute.sortValue.localeCompare(b.articleTypeAttribute.sortValue);
    });
  }

}
